"use client"

import { useEffect, useState } from "react"
import { models } from "powerbi-client"
import { PowerBIEmbed } from "powerbi-client-react"
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card"
import { apiClient } from "../lib/apiClient"

interface PlaceholderPageProps {
  title: string
  icon: React.ReactNode
}

interface PowerBIEmbedConfig {
  embedUrl: string
  embedToken: string
  reportId: string
}

export function PlaceholderPage({ title, icon }: PlaceholderPageProps) {
  const [embedConfig, setEmbedConfig] = useState<PowerBIEmbedConfig | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false

    apiClient
      .get("/Reports/embedtoken")
      .then((res) => {
        if (cancelled) return
        setEmbedConfig({
          embedUrl: res.data.embedUrl,
          embedToken: res.data.embedToken,
          reportId: res.data.reportId,
        })
      })
      .catch((err) => {
        if (cancelled) return
        setError(err?.response?.data?.message || "Failed to load report.")
      })

    return () => {
      cancelled = true
    }
  }, [])

  return (
    <div className="p-4 sm:p-6 space-y-6">
      <Card>
        <CardHeader className="border-b">
          <CardTitle className="text-2xl font-semibold text-gray-900 flex items-center gap-2">
            {icon}
            {title}
          </CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          {error && <div className="p-4 text-sm text-red-600">{error}</div>}
          {!error && embedConfig && (
            <PowerBIEmbed
              embedConfig={{
                type: "report",
                id: embedConfig.reportId,
                embedUrl: embedConfig.embedUrl,
                accessToken: embedConfig.embedToken,
                tokenType: models.TokenType.Embed,
                settings: {
                  panes: {
                    filters: { expanded: false, visible: true },
                  },
                },
              }}
              cssClassName="w-full h-[800px] border-0"
            />
          )}
        </CardContent>
      </Card>
    </div>
  )
}
